import { T } from "../constants";

export default function Footer() {
  return (
    <div style={{
      background: T.mossDark,
      color: "rgba(212,232,160,0.3)",
      textAlign: "center", padding: "1.5rem",
      fontSize: "0.72rem", letterSpacing: "0.06em",
    }}>
      Earthy Mujer &nbsp;·&nbsp; Built with 🌿 by Cynthia Rico Cook &nbsp;·&nbsp; Not medical advice
    </div>
  );
}
